import { Message } from './supabase-types';

const ACTIVE_SESSION_KEY = 'active_chat_session';
const SESSION_MESSAGES_KEY = 'chat_session_messages';

interface StoredSession {
  id: string;
  messages: Message[];
  isAnonymous: boolean;
  lastUpdated: string;
}

export const saveActiveSession = (sessionId: string, messages: Message[], isAnonymous: boolean) => {
  const session: StoredSession = {
    id: sessionId,
    messages,
    isAnonymous,
    lastUpdated: new Date().toISOString()
  };
  localStorage.setItem(ACTIVE_SESSION_KEY, JSON.stringify(session));
};

export const getActiveSession = (): StoredSession | null => {
  const stored = localStorage.getItem(ACTIVE_SESSION_KEY);
  if (!stored) return null;
  
  try {
    const session = JSON.parse(stored) as StoredSession;
    // Only return sessions less than 24 hours old
    const lastUpdated = new Date(session.lastUpdated);
    const now = new Date();
    const hoursDiff = (now.getTime() - lastUpdated.getTime()) / (1000 * 60 * 60);
    
    if (hoursDiff > 24) {
      localStorage.removeItem(ACTIVE_SESSION_KEY);
      return null;
    }
    
    return session;
  } catch (error) {
    console.error('Error parsing stored session:', error);
    localStorage.removeItem(ACTIVE_SESSION_KEY);
    return null;
  }
};

export const clearActiveSession = () => {
  localStorage.removeItem(ACTIVE_SESSION_KEY);
  localStorage.removeItem(SESSION_MESSAGES_KEY);
  localStorage.removeItem('stored_takeaway');
  localStorage.removeItem('stored_messages');
};